import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCashPaymentBill = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "cash-payment-bill" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .75,
			y1: 14.25,
			x2: .75,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M.75,21.75h16.5a3,3,0,0,0-3-3H10.5a3,3,0,0,0-3-3H.75"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 18.75,
			x2: 10.5,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.875,3a.375.375,0,1,1-.375.375A.375.375,0,0,1,7.875,3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.625,9a.375.375,0,1,1-.375.375A.375.375,0,0,1,20.625,9"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M6.635.75h15.23A1.4,1.4,0,0,1,23.25,2.156v8.438A1.4,1.4,0,0,1,21.865,12H6.635A1.4,1.4,0,0,1,5.25,10.594V2.156A1.4,1.4,0,0,1,6.635.75Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 14.25,
			cy: 6,
			r: 2.25
		})
	]
});
export default SvgCashPaymentBill;
